const sessionOfferTypes = {
	OPEN_POSITION_RECORDER: "OPEN_POSITION_RECORDER",
	ANY_RECORDER_IN_TEAM: "ANY_RECORDER_IN_TEAM",
};
export default sessionOfferTypes;
